// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Esusf","fullView":"styles_fullView__1k399"};